export default class MemberHelper {
  static getCurrentLoggedInMemberFromPolicy = function (selectedPolicy) {
    let defaultMember = {
      FullName: "",
      IsLoggedInMember: false,
      DateOfBirth: "",
      IsOverageDependant: false,
      Address: {},
      PhoneNumbers: [],
      DocumentPreference: false,
      IsPolicyHolder: false,
      MemberBankDetail:{
        AccountNumber: null,
        SortCode: null,
        AccountHolderName: null,
       
      }
    };

    if (selectedPolicy && selectedPolicy.Members) {
      let member = selectedPolicy.Members.find(function (member) {
        return member.IsLoggedInMember === true;
      });

      if (member === undefined) {
        return defaultMember;
      }
      return member;
    }
    return defaultMember;
  };
}

export const getCurrentLoggedInMemberFromPolicy =
  MemberHelper.getCurrentLoggedInMemberFromPolicy;
